export default {"src":"/_next/static/media/positive-polygon.070f6c52.svg","height":15,"width":18};